import Vue from 'vue'
import axios from '../axios'
import jquery from 'jquery'
import Cookies from "js-cookie";

/**
 *宋建国：2019/12/27 11:38
 *描述：加载容器组件、展示组件、功能组件源代码
 *版本：1.0
 */
export const IngleComponent = (ExampleVue,loadPath = "",componentName) => {
  return new Promise((resolve, reject) => {
      if (ExampleVue.$tu.isBlank(componentName)) {
        reject("IngleComponent方法:要加载的组件名称不能为空");
        return;
      }
    /**
     *宋建国：2020/2/11 16:19
     *描述：是否进入拖拽设计界面 false:没有进入，true: 已经进入拖拽设计页面
     *版本：1.0
     */
      let existIntoDrag = true;  //false: 在拖拽页面
      let drapRoutePath = ExampleVue.$store.state.app.drapRoutePath; //如果在拖拽页面，则为“菜单路由”的路由路径，如果不在拖拽页面，则为空
      if(ExampleVue.$tu.isBlank(drapRoutePath)){
        //不在拖拽页面
        existIntoDrag = false;
      }
      /**
       *宋建国：2020/1/4 10:13
       *描述：判断组件是否存在
       *版本：1.0
       */
      let tmpComp = ExampleVue.$options.components[componentName];
      if (ExampleVue.$tu.isFunction(tmpComp)) {
        console.info("IngleComponent方法:" + componentName + ",组件已加载");
        resolve(tmpComp);
        return;
      }
      let importUrl = null;
      let menu = loadPath.split('/')[0]
      let url = loadPath.replace(menu+'/','')
      if(menu == 'components'){
        importUrl = import(`@/components/${url}`)
      }else if(menu == 'views'){
        importUrl = import(`@/views/${url}`)
      }else{
        importUrl = import(`@/views/${loadPath}`);
      }
      importUrl.then(res => {
        let tmpComps = () => {return importUrl}
        console.info("IngleComponent方法:" + componentName + ",组件本地源码"+ loadPath +"加载");
        resolve(tmpComps);
        return;
      }).catch( err => {
        let removeState = true;
        let sourceCodeObj = null;
        if (sessionStorage.getItem("expireDate")) {
          if (sessionStorage.getItem("expireDate") < Date.now()) {
            sessionStorage.clear();
            localStorage.clear();
            xyjVue.$message.error("登录过期，请重新登录")
            ExampleVue.$router.push("/Login");
            reject("登录过期，请重新登录")
            return;
          }
        }
        ExampleVue.$getItem(componentName, (err, value) => {
          if (!err) {
            /**
             *宋建国：2020/2/5 14:39
             *描述：true: 远程加载，false: 本地加载
             *版本：1.0
             */
            if (value !== null) {
              try {
                sourceCodeObj = JSON.parse(value);
                removeState = ExampleVue.$store.getters.getComponentVersion(componentName, sourceCodeObj.version);
              } catch (e) {
                console.error(e);
              }
            }
          }
          /**
           *宋建国：2020/2/5 14:27
           *描述：对比源码是否是最新版本
           * true：从远端加载
           * false：从本地加载
           *版本：1.0
           */
          if(removeState){
            axios({
              hostUrl: ExampleVue.baseUrl,
              url: '/sysMenuRoute/findByAllRouteName?componentName='+componentName,
              method: 'get',
            }).then((res) => {
              if (res.code !== 200) {
                console.error("IngleComponent方法:组件名称（" + componentName + "),远程读取错误号," + res.code);
                reject("IngleComponent方法:组件名称（" + componentName + "),远程读取错误号," + res.code);
                return;
              }
              if(ExampleVue.$tu.isBlank(res.data)){
                reject("IngleComponent方法:组件名称（" + componentName + "),远程服务器中不存在");
                console.error("IngleComponent方法:组件名称（" + componentName + "),远程服务器中不存在");
                return;
              }
              let component = res.data;
              if(ExampleVue.$tu.isBlank(component.componentCode)){
                reject("IngleComponent方法:组件名称（" + componentName + "),远程源码不能为空");
                console.error("IngleComponent方法:组件名称（" + componentName + "),远程源码不能为空");
                return;
              }
              let tmpComponent = ExampleVue.$XyjVueLoader(component.componentCode, componentName);
              if(!existIntoDrag){
                //存储远程代码到本地
                let saveSourceCode = {
                  componentCode: component.componentCode,
                  componentPath: component.elementName,
                  version: component.componentVersion
                };
                ExampleVue.$setItem(componentName,JSON.stringify(saveSourceCode));
                Vue.component(componentName, tmpComponent);
              }
              console.info("IngleComponent方法:" + componentName + ",组件名称远程加载成功");
              resolve(tmpComponent);
            }).catch((error) => {
              console.error("IngleComponent方法:" + componentName + ",组件名称远程读取失败," + error);
              reject(error);
            });
          }else{
            let tmpComponent = ExampleVue.$XyjVueLoader(sourceCodeObj.componentCode, componentName);
            if(!existIntoDrag){
              Vue.component(componentName, tmpComponent);
            }
            console.info("IngleComponent方法:" + componentName + ",组件本地缓存读取成功");
            resolve(tmpComponent);
          }
        });
      });
    }
  )
}
/**
 *宋建国：2020/2/11 16:31
 *描述：读取所有远程基础组件
 *版本：1.0
 */
export const AllComponent = (ExampleVue,type) => {
  return new Promise((resolve, reject) => {
      axios({
        hostUrl: ExampleVue.baseUrl,
        url: '/sysComponent/findByTree?type='+type,
        method: 'get',
      }).then((res) => {
        if (res.code != 200) {
          reject('读取远程组件错误号：' + res.code);
          return;
        }
        let componentArray = res.data;
        let arr = componentArray.map(item => {
        	let obj = {};
        	for(let key in item){
        		obj.label = key;
        		obj.value = item[key].map(_item => { 
		          let _obj = {};
        			_obj.name = _item.componentName;
        			_obj.type = 'business';
              _obj.component = _item.elementName;
              _obj.componentChineseName = _item.componentChineseName;
        			return _obj;
        		})
        	}
        	return obj;
        })
        resolve(arr)
      })
    }
  )
}

function findRoutesComp(ExampleVue,routes,componentName) {
  if(ExampleVue.$tu.isBlank(componentName)){
    console.error("findRoutesComp方法:要查找的路由名称不能为空");
    return false;
  }
  for(let i=0; i<routes.length; i++){
    if(routes[i].name === componentName){
      return true;
    }
    if(!ExampleVue.$tu.isObjectBlank(routes[i].children)){
      if(routes[i].children.length>0){
        if(findRoutesComp(ExampleVue,routes[i].children,componentName)){
          return true;
        }
      }
    }
  }
  return false;
}

/**
 *宋建国：2020/2/24 22:21
 *描述：根据路由路径递归查找route
 *版本：1.0
 */
function routesObjcet(ExampleVue,routes,routePath) {
  if(ExampleVue.$tu.isBlank(routePath)){
    console.error("routesObjcet:要查找的路由路径不能为空");
    return null;
  }
  for(let i=0; i<routes.length; i++){
    if(routes[i].path === routePath){
      return routes[i];
    }
    if(!ExampleVue.$tu.isObjectBlank(routes[i].children)){
      if(routes[i].children.length>0){
        let tmpRoute = routesObjcet(ExampleVue,routes[i].children,routePath);
        if(tmpRoute !== null){
          return tmpRoute;
        }
      }
    }
  }
  return null;
}

/**
 *宋建国：2020/3/1 21:30
 *描述：递归删除数组元素
 *版本：1.0
 */
function delRouterName(ExampleVue, router, componentName) {
  for(let i = router.length-1; i>=0; i--){
    if(router[i].name === componentName){
      router.splice(i,1);
    }else if(!ExampleVue.$tu.isBlank(router[i].children)){
      delRouterName(ExampleVue,router[i].children,componentName);
    }
  }
}

/**
 *宋建国：2020/1/5 10:49
 *描述：路由跳转时，加载组件
 * 注意，此方法跳转前，需要判断组件是否已经在路由表中，如果不存在，则加载顺序是，先到本地查找，在到远程查找
 * componentName: 远端组件名称
 * chinesename:组件中文名称   
 * processKey:组件流程定义key
 * loadPath: 如果组件确定从远程加载变量不需要传入，本地加载组件时需要写入组件路径
 * location {componentName:'',loadPath:'',chinesename:'',processKey:''}
 *版本：1.0
 */
export const XyjPcRoutesPush = (ExampleVue,location) => {
  return new Promise((resolve, reject) => {
    if (ExampleVue.$tu.isBlank(location.componentName)) {
       ExampleVue.$message.error("XyjPcRoutesPush方法:要加载的组件名称不能为空");
       reject("XyjPcRoutesPush方法:要加载的组件名称不能为空");
       return;
    }
    let drapRoutePath = ExampleVue.$store.state.app.drapRoutePath; //如果在拖拽页面，则为“菜单路由”的路由路径，如果不在拖拽页面，则为空
    if(ExampleVue.$tu.isBlank(drapRoutePath)){
      drapRoutePath = '/';
    }
    //移动端父路由，根据路由路径查找
    let rootRoute = routesObjcet(ExampleVue,ExampleVue.$router.options.routes,drapRoutePath);
    if(ExampleVue.$tu.isObjectBlank(rootRoute)){
        ExampleVue.$message.error("XyjPcRoutesPush方法:父路由不存在");
        reject("XyjPcRoutesPush方法:父路由不存在");
        return;
    }
    if(ExampleVue.$tu.isObjectBlank(rootRoute.children)){
      rootRoute['children'] = [];
    }
    if(!ExampleVue.$tu.isBlank(ExampleVue.$store.state.app.drapRoutePath)){
      //拖拽页面删除已加载组件，实现拖拽页面刷新加载最新
      delRouterName(ExampleVue,ExampleVue.$router.options.routes,location.componentName);
    }
    let existState = findRoutesComp(ExampleVue,rootRoute.children, location.componentName);
    if(existState){
      rootRoute.children.filter(x => x.path == location.componentName)[0].meta.busId = ''
      rootRoute.children.filter(x => x.path == location.componentName)[0].meta.name = location.chinesename
      resolve('XyjPcRoutesPush方法:' + location.componentName + '路由名称，路由数组已经存在，不用重新加载');
      console.info('XyjPcRoutesPush方法:' + location.componentName + '路由名称，路由数组已经存在，不用重新加载');
      return;
    }
    //根据路径加载本地组件
    let importUrl = null;
    let menu = location.loadPath.split('/')[0]
    let url = location.loadPath.replace(menu+'/','');
    if(menu == 'components'){
      importUrl = import(`@/components/${url}`)
    }else if(menu == 'views'){
      importUrl = import(`@/views/${url}`)
    }else{
      importUrl = import(`@/views/${location.loadPath}`);
    }
    importUrl.then((res)=>{
      /**
       *宋建国：2020/2/7 16:24
       *描述：本地源码加载
       *版本：1.0
       */
      //let tmpComps = () => {return importUrl}
      let path = {
        path: location.componentName,
        name: location.componentName,
        component: res,
        meta:{
          name: location.chinesename,
          processKey:location.processKey,
          tabs:location.tabs
        }
      }
      rootRoute.children.push(path);
      ExampleVue.$router.addRoutes(ExampleVue.$router.options.routes);
      console.info("XyjPcRoutesPush方法:" + location.componentName + "组件,通过本地源码加载成功");
      resolve("XyjPcRoutesPush方法:" + location.componentName + "组件,通过本地源码加载成功");
      return;
    }).catch((error)=>{ //本地源码加载失败
      let removeState = true;
      let sourceCodeObj = null;
      if (sessionStorage.getItem("expireDate")) {
        if (sessionStorage.getItem("expireDate") < Date.now()) {
          sessionStorage.clear();
          localStorage.clear();
          xyjVue.$message.error("登录过期，请重新登录")
          ExampleVue.$router.push("/Login");
          reject("登录过期，请重新登录")
          return;
        }
      }
      if(ExampleVue.$tu.isBlank(ExampleVue.$store.state.app.drapRoutePath)) {
        //非拖拽页面时，执行
        // sourceCode = localStorage.getItem(location.componentName);
        ExampleVue.$getItem(location.componentName, (err, value) => {
          if (!err) {
            /**
             *宋建国：2020/2/5 14:39
             *描述：true: 远程加载，false: 本地加载
             *版本：1.0
             */
            if (value !== null) {
              try {
                sourceCodeObj = JSON.parse(value);
                removeState = ExampleVue.$store.getters.getComponentVersion(location.componentName, sourceCodeObj.version);
              } catch (e) {
                console.error(e);
              }
            }
          }
          if(removeState) {
            /**
             *宋建国：2020/2/7 15:36
             *描述：重新远程加载组件
             *版本：1.0
             */
            let token = sessionStorage.getItem('tkn');
            jquery.ajax({
              headers: {"token": token, "Content-Type": "application/json;charset=UTF-8"},
              type:'GET',
              url: ExampleVue.baseUrl + '/sysMenuRoute/findByAllRouteName?componentName='+location.componentName,
              async:false,
              success:function(res){
                if (res.code != 200) {
                  console.error("XyjPcRoutesPush方法:组件名称（" + location.componentName + "),远程读取错误号," + res.code);
                  reject("XyjPcRoutesPush方法:组件名称（" + location.componentName + "),远程读取错误号," + res.code);
                  return;
                }
                let componentArray = res.data;
                if(ExampleVue.$tu.isBlank(res.data)){
                  console.error("XyjPcRoutesPush方法:组件名称(" + location.componentName + "),远程服务器中不存在");
                  reject("XyjPcRoutesPush方法:组件名称(" + location.componentName + "),远程服务器中不存在");
                  return;
                }
                //加载代码
                let tmpComponent = ExampleVue.$XyjVueLoader(componentArray.componentCode);
                tmpComponent().then((comp) => {
                  let path = {
                    path: componentArray.elementName,
                    name: location.componentName,
                    component: comp,
                    meta:{
                      name: location.chinesename,
                      processKey:location.processKey,
                      tabs:location.tabs
                    }
                  }
                  //非拖拽页面
                  let saveSourceCode = {
                    componentCode: componentArray.componentCode,
                    componentPath: componentArray.elementName,
                    version: componentArray.componentVersion
                  };
                  ExampleVue.$setItem(location.componentName,JSON.stringify(saveSourceCode));
                  rootRoute.children.push(path);
                  ExampleVue.$router.addRoutes(ExampleVue.$router.options.routes);
                  localStorage.setItem("storeRoute", JSON.stringify(path));
                  // localStorage.setItem("storeRoute", JSON.stringify(ExampleVue.$router.options.routes));
                  resolve("XyjPcRoutesPush方法:组件名称(" + location.componentName + ")，远程加载成功");
                  console.info("XyjPcRoutesPush方法:组件名称(" + location.componentName + ")，远程加载成功");
                });
              },
              error: function (err) {
                ExampleVue.$message.error(err.responseJSON.message);
                reject("XyjPcRoutesPush方法:组件名称(" + location.componentName + "),远程加载错误," + err.responseJSON.message);
              }
            });
          }else{
            /**
             *宋建国：2020/2/7 16:07
             *描述：本地缓存加载组件
             *版本：1.0
             */
            let tmpComponent = ExampleVue.$XyjVueLoader(sourceCodeObj.componentCode);
            tmpComponent().then((comp) =>{
              let path = {
                path: sourceCodeObj.componentPath,
                name: location.componentName,
                component: tmpComponent,
                meta:{
                  name: location.chinesename,
                  processKey:location.processKey,
                  tabs:location.tabs
                }
              }
              rootRoute.children.push(path);
              ExampleVue.$router.addRoutes(ExampleVue.$router.options.routes);
              localStorage.setItem("storeRoute", JSON.stringify(path));
              // localStorage.setItem("storeRoute", JSON.stringify(ExampleVue.$router.options.routes));
              console.info("XyjPcRoutesPush方法:组件名称(" + location.componentName + ")，本地缓存加载成功");
              resolve("XyjPcRoutesPush方法:组件名称(" + location.componentName + ")，本地缓存加载成功");
            });
          }
        });
      }else{
        //拖拽页面
        /**
         *宋建国：2020/2/7 15:36
         *描述：重新远程加载组件
         *版本：1.0
         */
        let token = sessionStorage.getItem('tkn');
        jquery.ajax({
          headers: {"token": token, "Content-Type": "application/json;charset=UTF-8"},
          type:'GET',
          url: ExampleVue.baseUrl + '/sysMenuRoute/findByAllRouteName?componentName='+location.componentName,
          async:false,
          success:function(res){
            if (res.code != 200) {
              console.error("XyjPcRoutesPush方法:组件名称（" + location.componentName + "),远程读取错误号," + res.code);
              reject("XyjPcRoutesPush方法:组件名称（" + location.componentName + "),远程读取错误号," + res.code);
              return;
            }
            let componentArray = res.data;
            if(ExampleVue.$tu.isBlank(res.data)){
              console.error("XyjPcRoutesPush方法:组件名称(" + location.componentName + "),远程服务器中不存在");
              reject("XyjPcRoutesPush方法:组件名称(" + location.componentName + "),远程服务器中不存在");
              return;
            }
            //加载代码
            let tmpComponent = ExampleVue.$XyjVueLoader(componentArray.componentCode);
            tmpComponent().then((comp) => {
              let path = {
                path: componentArray.elementName,
                name: location.componentName,
                component: comp,
                meta:{
                  name: location.chinesename,
                  processKey:location.processKey,
                  tabs:location.tabs
                }
              }
              rootRoute.children.push(path);
              ExampleVue.$router.addRoutes(ExampleVue.$router.options.routes);
              resolve("XyjPcRoutesPush方法:组件名称(" + location.componentName + ")，远程加载成功");
              console.info("XyjPcRoutesPush方法:组件名称(" + location.componentName + ")，远程加载成功");
            });
          },
          error: function (err) {
            ExampleVue.$message.error(err.responseJSON.message);
            reject("XyjPcRoutesPush方法:组件名称(" + location.componentName + "),远程加载错误," + err.responseJSON.message);
          }
        });
      }

      });
    }
  );
}



// WEBPACK FOOTER //
// ./src/http/moudules/component.js